module.exports = __webpack_public_path__ + "static/media/willow2.d0a77e84.jpg";